/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForMsVmm extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForMsVmm");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForMsVmm.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForMsVmm>): ServiceAccountCredentialsForMsVmm {
        let obj = Object.assign(new ServiceAccountCredentialsForMsVmm(), model);
        ServiceAccountCredentialsForMsVmm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForMsVmm>): ServiceAccountCredentialsForMsVmm {
        if (!model) return null;
        return ServiceAccountCredentialsForMsVmm.newInstance(<ServiceAccountCredentialsForMsVmm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForMsVmm) {
        if (!obj) return;

        models.ServiceAccountCredentialsForMsVmm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForMsVmm): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForMsVmm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
